
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.2.0
 * @copyright  Copyright (C) 2024-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 * @changelog
 *  2024-08-23 (1.0.0) (jhoward)
 *    - Refactor textual default section from <textual-menu> to <default-textual-section>.
 *
 *  2024-08-26 (1.1.0) (jhoward)
 *    - Handle selected menu items via store in <default-textual-section>.
 *    - Add scoped CSS in <default-textual-section>.
 *    - Customize item grid in <default-textual-section> based on rows in each item.
 *
 *  2024-12-03 (1.1.1) (jhoward)
 *    - Add isCartEnabled prop to <default-textual-section>.
 *    - Do not show "favorite" icon when isCartEnabled prop is set to false in <default-textual-section>.
 *
 *  2025-02-11 (1.2.0) (jhoward)
 *    - Add <menu-schedules> to the <defaultTextualSection> component if in admin view.
 */

import {defineComponent, PropType} from 'vue'
import MenuTagLegend from "../../menu-tag-legend.vue";
import MenuTag from "../../menu-tag.vue";
import {Menu, MenuItem, MenuSection} from "../../defs";
import {computedIsScheduled, isNormalizedScheduleActive} from "../../../../helpers/menu-sections";
import MenuVersion from "../../menu-version.vue";
import DefaultItem from "../../item/textual/defaultTextualItem.vue";
import MenuSchedules from "../../schedule/MenuSchedules.vue";

export default defineComponent({
  name: "defaultTextualSection",
  components: {MenuSchedules, DefaultItem, MenuVersion, MenuTag, MenuTagLegend},
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    items: {
      type: Array as PropType<MenuItem[]>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu | null>,
      required: true
    },
    isCartEnabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      maxItemRows: 1,
    };
  },
  computed: {
    isScheduled: computedIsScheduled,
    isEmpty(): boolean {
      if (this.section.menu_items && this.section.menu_items.length) {
        for (let i = 0, l = this.section.menu_items?.length || 0; i < l; i++) {
          if (0 === this.section.menu_items[i].normalizedSchedules?.length) {
            return false;
          }
          for (let ii = 0, ll = this.section.menu_items[i].normalizedSchedules?.length || 0; ii < ll; ii++) {
            if (isNormalizedScheduleActive(this.section.menu_items[i].normalizedSchedules[ii], this.$store.state.currentDateTimeUtc, this.$store.state.currentDayOfWeek, this.$store.state.currentTimeOfDay)) {
              return false;
            }
          }
        }
      }

      return true;
    },
  },
  methods: {
    sectionContentClasses(section: MenuSection): { [key: string]: boolean } {
      const output: { [key: string]: boolean } = {};
      if (section.menu_items) {
        output['item-count-' + section.menu_items.length] = true;
      }
      return output;
    },
    handleItemRows(rows: number) {
      if (rows > this.maxItemRows) {
        this.maxItemRows = rows;
      }
    },
  },
})
